import {
  ADD_INVOICE_ROUTE,
  BILLING_ROUTE,
  BUSINESS_SETTINGS_ROUTE,
  CLIENT_LIST_ROUTE,
  DASHBOARD_ROUTE,
  INVOICE_LIST_ROUTE,
} from '~/constants/routes';

export function getScreenNameFromPath(pathname: string): string {
  if (pathname.startsWith(DASHBOARD_ROUTE)) return 'Dashboard';
  if (pathname.startsWith(INVOICE_LIST_ROUTE)) return 'Invoices';
  if (pathname.startsWith(CLIENT_LIST_ROUTE)) return 'Clients';
  if (pathname.startsWith(BUSINESS_SETTINGS_ROUTE)) return 'Business Settings';
  if (pathname.startsWith(BILLING_ROUTE)) return 'Plan';
  if (pathname.startsWith(ADD_INVOICE_ROUTE)) return 'Add Invoice';
  if (pathname.startsWith(BUSINESS_SETTINGS_ROUTE)) return 'Add Business';
  return 'Unknown';
}
